import React, { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import requestApi from '../../utils/request'
import { useForm, Controller } from 'react-hook-form'
import {
    Col,
    Dropdown,
    Modal,
    ModalBody,
    ModalTitle,
    Row
} from 'react-bootstrap'
import AutoSuggestedTextBox from '../AutoCompleteTextbox/AutoCompleteTextbox'
import SearchableDropDown from '../SearchableDropDown/SearchableDropDown'
import InputControl from '../InputControl'
import { ReactComponent as IconClose } from '../../assets/images/icons/icon-modal-close.svg'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

//#region get All Main Category
const getAllMainCategory = async () => {
    const mainCats = await requestApi.post(
        '/main-category/list',
        {},
        { headers: true }
    )
    return mainCats.data
}
//#endregion

//#region get All sub-Category by mainCategoryId
const getSubCategoryByCategoryId = async ({ queryKey }) => {
    const subCats = await requestApi.post(
        '/category/list',
        { mainCategoryId: queryKey[1]._id },
        { headers: true }
    )
    return subCats.data
}
//#endregion

//#region All Materials
const getAllMaterials = async () => {
    const materialList = await requestApi.post(
        '/material/list',
        {},
        { headers: true }
    )
    return materialList.data
}
//#endregion

//#region All Types
const getAllTypes = async () => {
    const typeList = await requestApi.post('/type/list', {}, { headers: true })
    return typeList.data
}
//#endregion

//#region All Country
const getAllCountry = async () => {
    const countryList = await requestApi.post(
        '/country/list',
        { limit: 1000 },
        {},
        { headers: true }
    )
    return countryList.data
}
//#endregion

//#region All Estimated Time
const getAllEstimatedTime = async () => {
    const estimatedTimeList = await requestApi.post(
        '/shippingTime',
        {},
        { headers: true }
    )
    return estimatedTimeList.data
}
//#endregion

//#region  Validation Schema For Catalog Filter

const CatalogFilterValidation = yup.object({
    weight: yup.number().max(3, 'Please enter Valid Weight')
})
//#endregion

const FilterModal = ({
    ShowCatalogFilterPopup,
    setShowCatalogFilterPopup,
    MainCategory,
    setMainCategory,
    subCategory,
    setSubCategory,
    selectedMaterialOptions,
    setselectedMaterialOptions,
    selectedTypeOptions,
    setselectedTypeOptions,
    selectedCountryOptions,
    setselectedCountryOptions,
    selectedEstimatedTimeOptions,
    setselectedEstimatedTimeOptions,
    selectedsellerId,
    setselectedsellerId,
    selectedWeight,
    setselectedWeight,
    filter,
    state
}) => {
    const queryClient = useQueryClient()
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
        getValues
    } = useForm({
        // resolver: yupResolver(CatalogFilterValidation)
    })


    //#region  Main-category Listing
    const { data: MainCategoryList, isLoading } = useQuery({
        queryKey: ['maincategorylist', MainCategory],
        queryFn: getAllMainCategory
    })
    //#endregion

    //#region Category Listing By MaincategoryId
    const { data: subCategoryList } = useQuery({
        queryKey: ['subcategorylist', MainCategory],
        queryFn: getSubCategoryByCategoryId,
        enabled: Boolean(MainCategory?._id)
    })
    //#endregion

    //#region Material Listing
    const { data: MaterialList } = useQuery({
        queryKey: ['materiallist', selectedMaterialOptions],
        queryFn: getAllMaterials
    })
    //#endregion

    //#region Type Listing
    const { data: TypeList } = useQuery({
        queryKey: ['typelist', selectedTypeOptions],
        queryFn: getAllTypes
    })
    //#endregion

    //#region Country Listing
    const { data: CountryList } = useQuery({
        queryKey: ['countrylist', selectedCountryOptions],
        queryFn: getAllCountry
    })
    //#endregion

    //#region Estimated Time Listing
    const { data: EstimatedTime } = useQuery({
        queryKey: ['estimatedtimelist', selectedEstimatedTimeOptions],
        queryFn: getAllEstimatedTime
    })
    //#endregion

    //#region  Submit Button Filters
    const onFiltersSubmit = (data) => {
        filter(state)
        setShowCatalogFilterPopup(false)
    }
    //#endregion

    console.log(
        ShowCatalogFilterPopup,
        MainCategory,
        subCategory,
        selectedMaterialOptions,
        selectedTypeOptions,
        selectedCountryOptions,
        selectedEstimatedTimeOptions,
        selectedsellerId,
        selectedWeight,
        'getValues'
    )

    return (
        <Modal
        style={{backdropFilter: 'blur(2px)'}}
            centered
            className="modalbox confirm-modal filter-modal"
            show={ShowCatalogFilterPopup}
            onHide={() => setShowCatalogFilterPopup(false)}
        >
            <ModalBody>
                <div className="head">
                    <h2>Filter</h2>
                    <div
                        className="close"
                        onClick={() => {
                            setShowCatalogFilterPopup(false)
                        }}
                    >
                        <IconClose />
                    </div>
                </div>
                <form onSubmit={handleSubmit(onFiltersSubmit)}>
                    <Row>
                        {/* VendorName Dynamic-Custom AutoComplete TextBox Start */}
                        <Col lg="4" md="6" sm="12">
                            <div className="form-group">
                                <label>Vender Name</label>
                                {/* AutoComplete Textbox */}
                                <Controller
                                    control={control}
                                    name="fullName"
                                    render={({
                                        field: { value, onChange }
                                    }) => {
                                        return (
                                            <AutoSuggestedTextBox
                                                error={
                                                    errors?.fullName?.message
                                                }
                                                setValue={(e) => {
                                                    onChange(e)
                                                    setselectedsellerId(e)
                                                }}
                                                value={value}
                                            />
                                        )
                                    }}
                                />
                            </div>
                        </Col>
                        {/* VendorName Dynamic-Custom AutoComplete TextBox End */}
                        {/* Main-Category Dropdown Start */}
                        <Col lg="4" md="6" sm="12">
                            <div className="form-group">
                                <label>Category</label>
                                <Controller
                                    control={control}
                                    name="MainCategory"
                                    render={({
                                        field: { onChange, onBlur, value, ref }
                                    }) => (
                                        <Dropdown
                                            flip="no"
                                            onSelect={(e) => {
                                                setMainCategory(JSON.parse(e))
                                                setSubCategory({
                                                    categoryName:
                                                        'Select Sub-Category'
                                                })
                                            }}
                                            name="MainCategory"
                                            drop="down-centered"
                                            {...register('MainCategory')}
                                        >
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                {MainCategory?.name}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                {MainCategoryList?.data?.map(
                                                    (mCat) => {
                                                        return (
                                                            <Dropdown.Item
                                                                key={mCat._id}
                                                                eventKey={JSON.stringify(
                                                                    mCat
                                                                )}
                                                            >
                                                                {mCat.name}
                                                            </Dropdown.Item>
                                                        )
                                                    }
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                ></Controller>
                                {errors?.MainCategory && (
                                    <span
                                        className="error-message"
                                        style={{ color: 'red' }}
                                    >
                                        {' '}
                                        {errors?.MainCategory?.message}
                                    </span>
                                )}
                            </div>
                        </Col>
                        {/* Main-Category Dropdown End */}
                        {/* Sub-Category Dropdown Start */}
                        <Col lg="4" md="6" sm="12">
                            <div className="form-group">
                                <label>Sub Category</label>
                                <Controller
                                    control={control}
                                    name="subCategory"
                                    render={({
                                        field: { onChange, onBlur, value, ref }
                                    }) => (
                                        <Dropdown
                                            flip="no"
                                            onSelect={(e) =>
                                                setSubCategory(JSON.parse(e))
                                            }
                                            name="subCategory"
                                            drop="down-centered"
                                            {...register('subCategory')}
                                        >
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                {subCategory?.categoryName}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                {subCategoryList?.data?.map(
                                                    (sCat) => {
                                                        return (
                                                            <Dropdown.Item
                                                                key={
                                                                    sCat?.categoryId
                                                                }
                                                                eventKey={JSON.stringify(
                                                                    sCat
                                                                )}
                                                            >
                                                                {
                                                                    sCat?.categoryName
                                                                }
                                                            </Dropdown.Item>
                                                        )
                                                    }
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                ></Controller>
                                {errors?.subCategory && (
                                    <span
                                        className="error-message"
                                        style={{ color: 'red' }}
                                    >
                                        {' '}
                                        {errors?.subcategory?.message}
                                    </span>
                                )}
                            </div>
                        </Col>
                        {/* Sub-Category Dropdown End */}
                        {/* Material Dropdown start */}
                        <Col lg="4" md="6" sm="12">
                            <div className="form-group">
                                <label>Product Material</label>

                                <SearchableDropDown
                                    options={MaterialList?.data}
                                    control={control}
                                    name="material"
                                    onSelect={(e) =>
                                        setselectedMaterialOptions(e)
                                    }
                                />
                            </div>
                        </Col>
                        {/* Material Dropdown End */}
                        {/* Country Dropdown Start */}
                        <Col lg="4" md="6" sm="12">
                            <div className="form-group">
                                <label>Country of Origin</label>
                                <SearchableDropDown
                                    control={control}
                                    options={CountryList?.data}
                                    name="country"
                                    onSelect={(e) =>
                                        setselectedCountryOptions(e)
                                    }
                                />
                            </div>
                        </Col>
                        {/* Country Dropdown End */}
                        {/* Type DropDown Start */}
                        <Col lg="4" md="6" sm="12">
                            <div className="form-group">
                                <label>Product Type</label>
                                <SearchableDropDown
                                    control={control}
                                    options={TypeList?.data}
                                    name="type"
                                    onSelect={(e) => setselectedTypeOptions(e)}
                                />
                            </div>
                        </Col>
                        {/* Type DropDown End */}
                        {/* Weight textBox Start */}
                        <Col lg="4" md="6" sm="12">
                            <div className="form-group">
                                <InputControl
                                    type="number"
                                    min={0}
                                    onChange={(e) =>
                                        setselectedWeight(e.target.value)
                                    }
                                    label="Product Weight (gms)"
                                    name="weight"
                                    register={register}
                                    error={errors?.weight?.message}
                                    onPaste={(evt) => {
                                        evt.preventDefault()
                                    }}
                                    onKeyPress={(evt) => {
                                        if (evt.target.value.length > 2) {
                                            evt.preventDefault()
                                        }
                                        if (
                                            !(
                                                evt.charCode >= 46 &&
                                                evt.charCode <= 57
                                            )
                                        ) {
                                            evt.preventDefault()
                                        }
                                    }}
                                />
                            </div>
                        </Col>
                        {/* Weight textBox End */}
                        {/* Estimation Dropdown Start */}
                        <Col lg="4" md="6" sm="12">
                            <div className="form-group">
                                <label>Estimation Time</label>
                                <SearchableDropDown
                                    control={control}
                                    options={EstimatedTime?.data}
                                    name="estimatedtime"
                                    onSelect={(e) =>
                                        setselectedEstimatedTimeOptions(e)
                                    }
                                />
                            </div>
                        </Col>
                        {/* Estimation Dropdown End */}
                        <Col lg="12">
                            <div className="modal-btn-group">
                                <button className="solid-red-btn modal-btn">
                                    Apply
                                </button>
                                <button
                                    type="button"
                                    className="border-red-btn modal-btn"
                                    onClick={() => reset()}
                                >
                                    Reset
                                </button>
                            </div>
                        </Col>
                    </Row>
                </form>
            </ModalBody>
        </Modal>
    )
}

export default FilterModal
